import { ApplicationId } from "@1games-ru/region-shared/dist/enums/tablet/applicationd-id";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/core/store";

export interface TabletState {
  isShow: boolean;
  appsList: ApplicationId[];
  activeApp: ApplicationId;
  isVisible: boolean;
}

const initialState = {
  isShow: false,
  appsList: [],
  activeApp: null,
  isVisible: true,
};

const tabletSlice = createSlice({
  name: "tabletSlice",
  initialState,
  reducers: {
    setIsShow: (state, action: PayloadAction<boolean>) => {
      state.isShow = action.payload;
    },
    setAppsList: (state, action: PayloadAction<ApplicationId[]>) => {
      state.appsList = action.payload.sort((a, b) => a - b);
    },
    setActiveApp: (state, action: PayloadAction<ApplicationId>) => {
      state.activeApp = action.payload;
    },
    setIsVisible: (state, action: PayloadAction<boolean>) => {
      state.isVisible = action.payload;
    },
  },
});

export const tabltetIsShow = (state: RootState) => state.tablet.isShow;
export const devicesList = (state: RootState) => state.tablet.appsList;
export const tabletActiveApp = (state: RootState) => state.tablet.activeApp;
export const tabletIsVisible = (state: RootState) => state.tablet.isVisible;

export const tabletReducer = tabletSlice.reducer;
export const { setIsShow, setAppsList, setActiveApp, setIsVisible } = tabletSlice.actions;
